import api from '../api'

//data
const state = {
  status:{
    loading:false,
    loaded:false,
    error:'', // last error
    lastLoaded:''
  },
  items:[]


}

//comuted store.getters.inCart
const getters = {

}

//sync methods store.commit('increment')
const mutations = {


  SET_REFERENCES (state, data){
    state.items = data
  },

}

//async methods  store.dispatch('increment')
const actions = {


  loadReferences ({state, commit}) {

    api.get('reference')
      .then(function (response) {
        commit('SET_REFERENCES', response.data.data)

      })
      .catch(function (error) {


      });
  },



}


export default {
  state, mutations, actions, getters
}



// WEBPACK FOOTER //
// ./src/store/modules/ReferenceStore.js